module.exports = "https://coursera_assets.s3.amazonaws.com/images/abb81edb31d0f1c0b0e5ab8b57115416.png";